(function () {
  const root = document.querySelector('.tsar-hp--nav-only');
  if (!root) return;

  root.classList.add('is-js', 'is-ready');

  const previewId = root.getAttribute('data-preview-theme')
    || new URLSearchParams(window.location.search).get('preview_theme_id');

  const withPreview = (url) => {
    if (!previewId || !url) return url;
    if (/^(#|mailto:|tel:|javascript:)/i.test(url)) return url;
    try {
      const next = new URL(url, window.location.origin);
      if (next.origin !== window.location.origin) return url;
      if (!next.searchParams.has('preview_theme_id')) {
        next.searchParams.set('preview_theme_id', previewId);
      }
      return next.pathname + next.search + next.hash;
    } catch (err) {
      return url;
    }
  };

  if (previewId) {
    root.querySelectorAll('a[href]').forEach((link) => {
      link.setAttribute('href', withPreview(link.getAttribute('href')));
    });
  }

  const toggle = document.getElementById('menuToggle');
  const menu = document.getElementById('menu');

  if (toggle && menu) {
    const scrim = document.createElement('div');
    scrim.className = 'menu__scrim';
    root.appendChild(scrim);

    const setOpen = (open) => {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', String(!open));
      scrim.classList.toggle('is-open', open);
    };

    toggle.addEventListener('click', () => {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
    scrim.addEventListener('click', () => setOpen(false));
    menu.addEventListener('click', (e) => { if (e.target.closest('a')) setOpen(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setOpen(false); });
  }

  const openCart = () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    const bubble = document.querySelector('#cart-icon-bubble');
    if (bubble) bubble.click();
    else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  };

  root.querySelector('[data-hp-search]')?.addEventListener('click', (event) => {
    const href = event.currentTarget.getAttribute('data-href') || '/search';
    window.location.href = withPreview(href);
  });
  root.querySelector('[data-hp-cart]')?.addEventListener('click', openCart);
})();
